import { h, FunctionComponent } from 'preact';
import { useMemo } from 'preact/hooks';
import { useTranslation } from 'react-i18next';
import { Modal } from 'components/ModalV2';
import { RatingModalProps } from './RatingModal.interface';
import RatingForm from './components/RatingForm';
import RateSuccess from './components/RateSuccess';
import { useRatingModal } from './RatingModal.hooks';
import { BodyContainer } from './RatingModal.styles';

const RatingModal: FunctionComponent<RatingModalProps> = (props) => {
  const { globalConfig, lastRating, isOpen } = props;
  const { onClose, ratedSuccess, newRating, onRateSuccess } = useRatingModal(
    props.onClose,
    props.onRateSuccess,
  );

  const { t } = useTranslation();
  const { rating } = globalConfig.config || {};

  const headerText = useMemo(() => {
    const customText = ratedSuccess
      ? rating.confirmationMainTitle
      : rating.mainQuestion;
    return customText || t('RATING_MAIN_QUESTION');
  }, [ratedSuccess, rating.mainQuestion, rating.confirmationMainTitle, t]);

  const confirmationMessage = useMemo(() => {
    if (!ratedSuccess || !newRating?.value) {
      return null;
    }

    if (newRating.value >= 4) {
      return rating.confirmationPositive || rating.confirmation;
    }

    return rating.confirmationNegative || rating.confirmation;
  }, [
    ratedSuccess,
    newRating,
    rating.confirmationPositive,
    rating.confirmationNegative,
    rating.confirmation,
  ]);

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      aria={{
        labelledby: 'rating-modal-heading',
      }}
      key={ratedSuccess ? 'rated-success' : 'rating-form'}
    >
      <Modal.Header id="rating-modal-heading">{headerText}</Modal.Header>
      <Modal.Body>
        <BodyContainer>
          {ratedSuccess ? (
            <RateSuccess
              onClose={onClose}
              customMessage={confirmationMessage}
            />
          ) : (
            <RatingForm
              lastRating={lastRating}
              globalConfig={globalConfig}
              onRateSuccess={onRateSuccess}
            />
          )}
        </BodyContainer>
      </Modal.Body>
    </Modal>
  );
};

export default RatingModal;
